<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Month self Attendance
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-primary ms-1" [disabled]="isDisabled"
                    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseFilter">
                    <i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="p-1">
            <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
                <div class="row">
                    <!-- <div class="col-md-3 px-1">
                        <label class="Label">Month and Year</label>
                        <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year"
                            (navigate)="selectedMonth= $event.next;onNavigate()" name="dateselect"
                            (ngModelChange)="onchange('Date')" style="width: 100%;"></ngb-datepicker>
                    </div> -->

                    <div class="col-md-3 px-1">
                        <label class="Label">From Date <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="FromDate"
                                [(ngModel)]="Detail.From" ngbDatepicker #FromDate="ngbDatepicker"
                                (ngModelChange)="clearGrid()" required />
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                (click)="FromDate.toggle()"></button>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label class="Label">To Date <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="ToDate" [(ngModel)]="Detail.To"
                                ngbDatepicker #ToDate="ngbDatepicker" (ngModelChange)="clearGrid()" required />
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                                (click)="ToDate.toggle()"></button>
                        </div>
                    </div>

                    <div class="col-md-6 px-1">
                        <label class="Label">Branch</label>
                        <ng-select name="branch" [items]="BranchMasterLoad" bindLabel="BranchName"
                            bindValue="BranchMasterID" [(ngModel)]="Detail.BRANCHID"
                            (change)="ComboLoad('Client');onchange('Branch');clearGrid()" placeholder="Select Branch">
                        </ng-select>
                        <!-- <div class="invalid-feedback">
                            Please select Branch.
                        </div> -->
                    </div>
                    <div class="col-md-4 px-1">
                        <label class="Label">Client</label>
                        <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                            bindValue="ClientGroupMasterID" [(ngModel)]="Detail.CLIENTID"
                            (change)="ComboLoad('Site');onchange('Client');clearGrid()" placeholder="Select Client">
                        </ng-select>
                    </div>
                    <div class="col-md-4 px-1">
                        <label class="Label">Site</label>
                        <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                            [(ngModel)]="Detail.SITEID" (change)="onchange('Site');clearGrid()" placeholder="Select Site">
                        </ng-select>
                    </div>
                    <div class="col-md-2 px-1">
                        <label class="Label">Employee Code</label>
                        <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Detail.EMPCODE"
                            placeholder="Employee Code" />
                    </div>
                    <div class="col"><br>
                        <button type="submit" class="btn btn-sm btn-primary" [disabled]="isDisabled">
                            <i class="bi bi-search" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Search':'Loading...'}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="card border-radius-0 mt-3 p-0">
            <div class="card-header">
                <div class="row">
                    <div class="col"> Data</div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                            (click)="ViewAttandance()">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'View Summary':'Loading...'}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body p-1">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                            <th scope="col">Employee</th>
                            <th scope="col">Site Name</th>
                            <th scope="col">Date Of Joining</th>
                            <th scope="col">Present</th>
                            <th scope="col">Week Off</th>
                            <th scope="col">CompOff</th>
                            <th scope="col">Paid Leave</th>
                            <th scope="col">Paid Holiday</th>
                            <th scope="col">Mis Punch</th>
                            <th scope="col">Absent</th>
                            <th scope="col">Half Day</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of TableDatas; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                                <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                    (click)="EditAttandance(TableData)">
                                    <i class="bi bi-pencil-square text-warning"></i>
                                </button>
                            </td>
                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableData['Photo'])" />
                                        <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableData['FULLNAME'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <span class="text-label">{{TableData['FULLNAME']}}</span><br />
                                        <span class="text-label-light">#{{TableData['EMPCODE']}}</span><br />
                                        <span class="text-label-light">{{TableData['DesignationName']}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>{{TableData['SiteName']}}</td>
                            <td>{{TableData['JoiningDate']}}</td>
                            <td>{{TableData['PRESENT']}}</td>
                            <td>{{TableData['WEEK OFF']}}</td>
                            <td>{{TableData['CompOff']}}</td>
                            <td>{{TableData['PAID LEAVE']}}</td>
                            <td>{{TableData['PAID HOLIDAY']}}</td>
                            <td>{{TableData['MIS PUNCH']}}</td>
                            <td>{{TableData['ABSENT']}}</td>
                            <td>{{TableData['HALF DAY']}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" name="save">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div> -->
</div>